import classNames from 'classnames';
import React from 'react';

import LevelListItem, { LevelListItemProps } from './LevelListItem';

export interface LevelListProps {
  levels: LevelListItemProps[] | undefined;
  exampleBg?: boolean;
}

const LevelList: React.FC<LevelListProps> = (props) => {
  return (
    <div className={classNames('oejr-level-list', props.exampleBg && 'oejr-level-list-example-bg')}>
      {props.levels?.map((levelArgs, key) => (
        <LevelListItem {...levelArgs} key={key} />
      ))}
    </div>
  );
};

export default LevelList;
